<template>
  <div class="power-room-monitor-page">
    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabChange">
      <el-tab-pane label="配电室管理" name="room">
        <div class="filter-bar">
          <el-input v-model="roomQuery.roomCode" class="filter-item" clearable placeholder="配电室编码" />
          <el-input v-model="roomQuery.roomName" class="filter-item" clearable placeholder="配电室名称" />
          <el-select v-model="roomQuery.enabled" class="filter-item" clearable placeholder="启用状态">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="loadRooms">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetRoomQuery">重置</el-button>
        </div>
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="openRoomDialog()">新增</el-button>
        </div>
        <el-table v-loading="roomLoading" :data="roomRows" border stripe>
          <el-table-column prop="roomCode" label="编码" min-width="150" show-overflow-tooltip />
          <el-table-column prop="roomName" label="名称" min-width="170" show-overflow-tooltip />
          <el-table-column prop="monitorScope" label="监测范围" width="100" />
          <el-table-column prop="protocolType" label="协议" width="90" />
          <el-table-column prop="displayOrder" label="排序" width="80" />
          <el-table-column prop="enabled" label="状态" width="90">
            <template slot-scope="{ row }">
              <el-tag :type="row.enabled === 1 ? 'success' : 'info'" size="mini">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" @click="openRoomDialog(row)">编辑</el-button>
              <el-button type="text" size="small" class="el-button--danger" @click="removeRoom(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pager" background layout="total, sizes, prev, pager, next" :current-page.sync="roomPage.current" :page-size.sync="roomPage.size" :total="roomPage.total" @size-change="loadRooms" @current-change="loadRooms" />
      </el-tab-pane>

      <el-tab-pane label="104通道管理" name="channel">
        <div class="filter-bar">
          <el-select v-model="channelQuery.roomCode" class="filter-item" clearable filterable placeholder="配电室">
            <el-option v-for="item in roomOptions" :key="item.id" :label="item.roomName" :value="item.roomCode" />
          </el-select>
          <el-input v-model="channelQuery.channelCode" class="filter-item" clearable placeholder="通道编码" />
          <el-input v-model="channelQuery.host" class="filter-item" clearable placeholder="IP地址" />
          <el-select v-model="channelQuery.connectionStatus" class="filter-item" clearable placeholder="连接状态">
            <el-option label="已连接" value="CONNECTED" />
            <el-option label="连接中" value="CONNECTING" />
            <el-option label="异常" value="ERROR" />
            <el-option label="已停止" value="STOPPED" />
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="loadChannels">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetChannelQuery">重置</el-button>
        </div>
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="openChannelDialog()">新增</el-button>
        </div>
        <el-table v-loading="channelLoading" :data="channelRows" border stripe>
          <el-table-column prop="channelCode" label="通道编码" min-width="170" show-overflow-tooltip />
          <el-table-column prop="channelName" label="通道名称" min-width="180" show-overflow-tooltip />
          <el-table-column prop="roomCode" label="配电室" min-width="150" show-overflow-tooltip />
          <el-table-column prop="host" label="IP地址" min-width="130" />
          <el-table-column prop="port" label="端口" width="80" />
          <el-table-column prop="commonAddress" label="公共地址" width="90" />
          <el-table-column prop="autoStart" label="自启" width="80">
            <template slot-scope="{ row }">{{ row.autoStart === 1 ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="connectionStatus" label="连接状态" width="110">
            <template slot-scope="{ row }">
              <span :class="['status-dot', 'status-' + (row.connectionStatus || 'STOPPED')]" />
              {{ statusText(row.connectionStatus) }}
            </template>
          </el-table-column>
          <el-table-column prop="lastError" label="最近错误" min-width="180" show-overflow-tooltip />
          <el-table-column label="操作" width="300" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" @click="testChannel(row)">测试</el-button>
              <el-button type="text" size="small" @click="startChannel(row)">启动</el-button>
              <el-button type="text" size="small" @click="stopChannel(row)">停止</el-button>
              <el-button type="text" size="small" @click="restartChannel(row)">重启</el-button>
              <el-button type="text" size="small" @click="openChannelDialog(row)">编辑</el-button>
              <el-button type="text" size="small" class="el-button--danger" @click="removeChannel(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pager" background layout="total, sizes, prev, pager, next" :current-page.sync="channelPage.current" :page-size.sync="channelPage.size" :total="channelPage.total" @size-change="loadChannels" @current-change="loadChannels" />
      </el-tab-pane>

      <el-tab-pane label="点位管理" name="point">
        <div class="filter-bar">
          <el-select v-model="pointQuery.roomCode" class="filter-item" clearable filterable placeholder="配电室">
            <el-option v-for="item in roomOptions" :key="item.id" :label="item.roomName" :value="item.roomCode" />
          </el-select>
          <el-select v-model="pointQuery.channelCode" class="filter-item" clearable filterable placeholder="通道">
            <el-option v-for="item in channelOptions" :key="item.id" :label="item.channelName" :value="item.channelCode" />
          </el-select>
          <el-input v-model="pointQuery.pointName" class="filter-item" clearable placeholder="点位名称" />
          <el-select v-model="pointQuery.signalType" class="filter-item" clearable placeholder="信号类型">
            <el-option v-for="item in signalTypeOptions" :key="item" :label="item" :value="item" />
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="loadPoints">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetPointQuery">重置</el-button>
        </div>
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="openPointDialog()">新增</el-button>
        </div>
        <el-table v-loading="pointLoading" :data="pointRows" border stripe>
          <el-table-column prop="pointCode" label="点位编码" min-width="190" show-overflow-tooltip />
          <el-table-column prop="pointName" label="点位名称" min-width="210" show-overflow-tooltip />
          <el-table-column prop="roomCode" label="配电室" min-width="150" show-overflow-tooltip />
          <el-table-column prop="channelCode" label="通道" min-width="170" show-overflow-tooltip />
          <el-table-column prop="pointCategory" label="大类" width="90" />
          <el-table-column prop="signalKind" label="信号" width="80" />
          <el-table-column prop="signalType" label="类型" width="90" />
          <el-table-column prop="ioa" label="IOA" width="80" />
          <el-table-column prop="currentTextValue" label="当前值" min-width="110" show-overflow-tooltip />
          <el-table-column prop="alarmStatus" label="告警" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.alarmStatus === 1 ? 'danger' : 'success'" size="mini">{{ row.alarmStatus === 1 ? '告警' : '正常' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="lastCollectTime" label="采集时间" min-width="160" />
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" @click="openPointDialog(row)">编辑</el-button>
              <el-button type="text" size="small" class="el-button--danger" @click="removePoint(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pager" background layout="total, sizes, prev, pager, next" :current-page.sync="pointPage.current" :page-size.sync="pointPage.size" :total="pointPage.total" @size-change="loadPoints" @current-change="loadPoints" />
      </el-tab-pane>
    </el-tabs>

    <el-dialog :title="roomForm.id ? '编辑配电室' : '新增配电室'" :visible.sync="roomDialogVisible" width="620px" append-to-body>
      <el-form ref="roomForm" :model="roomForm" :rules="roomRules" label-width="110px">
        <el-form-item label="配电室编码" prop="roomCode"><el-input v-model="roomForm.roomCode" /></el-form-item>
        <el-form-item label="配电室名称" prop="roomName"><el-input v-model="roomForm.roomName" /></el-form-item>
        <el-form-item label="监测范围"><el-select v-model="roomForm.monitorScope"><el-option label="环境" value="ENV" /><el-option label="电量" value="ELECTRIC" /><el-option label="综合" value="BOTH" /></el-select></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="roomForm.displayOrder" :min="0" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="roomForm.enabled" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="roomForm.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="roomDialogVisible = false">取消</el-button><el-button type="primary" @click="saveRoom">保存</el-button></span>
    </el-dialog>

    <el-dialog :title="channelForm.id ? '编辑104通道' : '新增104通道'" :visible.sync="channelDialogVisible" width="760px" append-to-body>
      <el-form ref="channelForm" :model="channelForm" :rules="channelRules" label-width="130px">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="配电室" prop="roomId"><el-select v-model="channelForm.roomId" filterable><el-option v-for="item in roomOptions" :key="item.id" :label="item.roomName" :value="item.id" /></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="通道编码" prop="channelCode"><el-input v-model="channelForm.channelCode" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="通道名称" prop="channelName"><el-input v-model="channelForm.channelName" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="IP地址" prop="host"><el-input v-model="channelForm.host" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="端口" prop="port"><el-input-number v-model="channelForm.port" :min="1" :max="65535" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="公共地址"><el-input-number v-model="channelForm.commonAddress" :min="1" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="源地址"><el-input-number v-model="channelForm.originatorAddress" :min="0" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="COT字节"><el-input-number v-model="channelForm.cotSize" :min="1" :max="2" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="CA字节"><el-input-number v-model="channelForm.caSize" :min="1" :max="2" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="IOA字节"><el-input-number v-model="channelForm.ioaSize" :min="1" :max="3" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="重连间隔(ms)"><el-input-number v-model="channelForm.reconnectIntervalMs" :min="1000" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="总召周期(s)"><el-input-number v-model="channelForm.generalInterrogationIntervalSec" :min="30" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="服务自启"><el-switch v-model="channelForm.autoStart" :active-value="1" :inactive-value="0" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="启用"><el-switch v-model="channelForm.enabled" :active-value="1" :inactive-value="0" /></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer"><el-button @click="channelDialogVisible = false">取消</el-button><el-button type="primary" @click="saveChannel">保存</el-button></span>
    </el-dialog>

    <el-dialog :title="pointForm.id ? '编辑点位' : '新增点位'" :visible.sync="pointDialogVisible" width="820px" append-to-body>
      <el-form ref="pointForm" :model="pointForm" :rules="pointRules" label-width="120px">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="配电室" prop="roomId"><el-select v-model="pointForm.roomId" filterable><el-option v-for="item in roomOptions" :key="item.id" :label="item.roomName" :value="item.id" /></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="104通道"><el-select v-model="pointForm.channelId" filterable clearable><el-option v-for="item in channelOptions" :key="item.id" :label="item.channelName" :value="item.id" /></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="点位编码" prop="pointCode"><el-input v-model="pointForm.pointCode" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="点位名称" prop="pointName"><el-input v-model="pointForm.pointName" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="点位大类"><el-select v-model="pointForm.pointCategory"><el-option label="环境" value="ENV" /><el-option label="电量" value="ELECTRIC" /></el-select></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="信号种类"><el-select v-model="pointForm.signalKind"><el-option label="遥信" value="YX" /><el-option label="遥测" value="YC" /><el-option label="电量" value="YM" /></el-select></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="信号类型"><el-select v-model="pointForm.signalType" filterable allow-create><el-option v-for="item in signalTypeOptions" :key="item" :label="item" :value="item" /></el-select></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="IOA" prop="ioa"><el-input-number v-model="pointForm.ioa" :min="0" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="类型标识"><el-input-number v-model="pointForm.typeId" :min="0" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="值类型"><el-select v-model="pointForm.valueType"><el-option label="布尔" value="BOOLEAN" /><el-option label="数值" value="DECIMAL" /><el-option label="文本" value="TEXT" /></el-select></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="正常值"><el-input v-model="pointForm.normalStateValue" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="告警值"><el-input v-model="pointForm.alarmStateValue" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="单位"><el-input v-model="pointForm.unit" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="倍率"><el-input-number v-model="pointForm.scaleFactor" :precision="6" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="偏移"><el-input-number v-model="pointForm.offsetValue" :precision="6" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="小数位"><el-input-number v-model="pointForm.precisionScale" :min="0" :max="6" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="上限"><el-input-number v-model="pointForm.thresholdUpper" :precision="6" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="下限"><el-input-number v-model="pointForm.thresholdLower" :precision="6" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="排序"><el-input-number v-model="pointForm.displayOrder" :min="0" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="启用"><el-switch v-model="pointForm.enabled" :active-value="1" :inactive-value="0" /></el-form-item></el-col>
          <el-col :span="16"><el-form-item label="区域"><el-input v-model="pointForm.areaName" /></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer"><el-button @click="pointDialogVisible = false">取消</el-button><el-button type="primary" @click="savePoint">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import {
  roomPage, roomInsert, roomUpdate, roomRemove,
  channelPage, channelInsert, channelUpdate, channelRemove, channelStart, channelStop, channelRestart, channelTestConnect,
  pointPage, pointInsert, pointUpdate, pointRemove
} from './api'
import './index.scss'

const signalTypeOptions = ['通信', '红外', '温湿度', '水浸', '烟感', '电压', '电流', '功率', '电量']

export default {
  name: 'power-room-monitor-basic',
  data() {
    return {
      activeTab: 'room',
      signalTypeOptions,
      roomRows: [],
      roomOptions: [],
      roomLoading: false,
      roomQuery: {},
      roomPage: { current: 1, size: 10, total: 0 },
      roomDialogVisible: false,
      roomForm: this.emptyRoomForm(),
      roomRules: {
        roomCode: [{ required: true, message: '请输入配电室编码', trigger: 'blur' }],
        roomName: [{ required: true, message: '请输入配电室名称', trigger: 'blur' }]
      },
      channelRows: [],
      channelOptions: [],
      channelLoading: false,
      channelQuery: {},
      channelPage: { current: 1, size: 10, total: 0 },
      channelDialogVisible: false,
      channelForm: this.emptyChannelForm(),
      channelRules: {
        roomId: [{ required: true, message: '请选择配电室', trigger: 'change' }],
        channelCode: [{ required: true, message: '请输入通道编码', trigger: 'blur' }],
        channelName: [{ required: true, message: '请输入通道名称', trigger: 'blur' }],
        host: [{ required: true, message: '请输入IP地址', trigger: 'blur' }],
        port: [{ required: true, message: '请输入端口', trigger: 'change' }]
      },
      pointRows: [],
      pointLoading: false,
      pointQuery: {},
      pointPage: { current: 1, size: 10, total: 0 },
      pointDialogVisible: false,
      pointForm: this.emptyPointForm(),
      pointRules: {
        roomId: [{ required: true, message: '请选择配电室', trigger: 'change' }],
        pointCode: [{ required: true, message: '请输入点位编码', trigger: 'blur' }],
        pointName: [{ required: true, message: '请输入点位名称', trigger: 'blur' }],
        ioa: [{ required: true, message: '请输入IOA', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadRooms()
    this.loadRoomOptions()
    this.loadChannelOptions()
  },
  methods: {
    emptyRoomForm() {
      return { monitorScope: 'ENV', protocolType: 'IEC104', displayOrder: 0, enabled: 1 }
    },
    emptyChannelForm() {
      return { protocolType: 'IEC104', host: '127.0.0.1', port: 2404, commonAddress: 1, originatorAddress: 0, cotSize: 2, caSize: 2, ioaSize: 3, connectTimeoutMs: 5000, readTimeoutMs: 15000, reconnectIntervalMs: 60000, generalInterrogationIntervalSec: 60, autoStart: 1, enabled: 1 }
    },
    emptyPointForm() {
      return { pointCategory: 'ENV', signalKind: 'YX', signalType: '红外', valueType: 'BOOLEAN', normalStateValue: '0', alarmStateValue: '1', scaleFactor: 1, offsetValue: 0, precisionScale: 2, alarmStatus: 0, enabled: 1, displayOrder: 0 }
    },
    pagePayload(query, page) {
      return { ...query, current: page.current, size: page.size }
    },
    applyPage(targetPage, data) {
      targetPage.total = Number(data.total || 0)
    },
    loadRooms() {
      this.roomLoading = true
      roomPage(this.pagePayload(this.roomQuery, this.roomPage)).then((res) => {
        const data = res.data.data || {}
        this.roomRows = data.records || []
        this.applyPage(this.roomPage, data)
      }).finally(() => { this.roomLoading = false })
    },
    loadRoomOptions() {
      roomPage({ current: 1, size: 200, enabled: 1 }).then((res) => {
        this.roomOptions = (res.data.data || {}).records || []
      })
    },
    loadChannelOptions() {
      channelPage({ current: 1, size: 200, enabled: 1 }).then((res) => {
        this.channelOptions = (res.data.data || {}).records || []
      })
    },
    resetRoomQuery() {
      this.roomQuery = {}
      this.roomPage.current = 1
      this.loadRooms()
    },
    openRoomDialog(row) {
      this.roomForm = row ? { ...row } : this.emptyRoomForm()
      this.roomDialogVisible = true
    },
    saveRoom() {
      this.$refs.roomForm.validate((valid) => {
        if (!valid) return
        const api = this.roomForm.id ? roomUpdate : roomInsert
        api(this.roomForm).then(() => {
          this.$message.success('保存成功')
          this.roomDialogVisible = false
          this.loadRooms()
          this.loadRoomOptions()
        })
      })
    },
    removeRoom(row) {
      this.$confirm('确认删除该配电室？', '提示').then(() => roomRemove(row.id)).then(() => {
        this.$message.success('删除成功')
        this.loadRooms()
        this.loadRoomOptions()
      })
    },
    loadChannels() {
      this.channelLoading = true
      channelPage(this.pagePayload(this.channelQuery, this.channelPage)).then((res) => {
        const data = res.data.data || {}
        this.channelRows = data.records || []
        this.applyPage(this.channelPage, data)
      }).finally(() => { this.channelLoading = false })
    },
    resetChannelQuery() {
      this.channelQuery = {}
      this.channelPage.current = 1
      this.loadChannels()
    },
    openChannelDialog(row) {
      this.channelForm = row ? { ...row } : this.emptyChannelForm()
      this.channelDialogVisible = true
    },
    saveChannel() {
      this.$refs.channelForm.validate((valid) => {
        if (!valid) return
        const api = this.channelForm.id ? channelUpdate : channelInsert
        api(this.channelForm).then(() => {
          this.$message.success('保存成功')
          this.channelDialogVisible = false
          this.loadChannels()
          this.loadChannelOptions()
        })
      })
    },
    removeChannel(row) {
      this.$confirm('确认删除该104通道？', '提示').then(() => channelRemove(row.id)).then(() => {
        this.$message.success('删除成功')
        this.loadChannels()
        this.loadChannelOptions()
      })
    },
    testChannel(row) {
      channelTestConnect(row.id).then((res) => {
        this.$message.success((res.data && res.data.data) || '连接成功')
        this.loadChannels()
      })
    },
    startChannel(row) {
      channelStart(row.id).then(() => {
        this.$message.success('启动已提交')
        this.loadChannels()
      })
    },
    stopChannel(row) {
      channelStop(row.id).then(() => {
        this.$message.success('停止成功')
        this.loadChannels()
      })
    },
    restartChannel(row) {
      channelRestart(row.id).then(() => {
        this.$message.success('重启已提交')
        this.loadChannels()
      })
    },
    loadPoints() {
      this.pointLoading = true
      pointPage(this.pagePayload(this.pointQuery, this.pointPage)).then((res) => {
        const data = res.data.data || {}
        this.pointRows = data.records || []
        this.applyPage(this.pointPage, data)
      }).finally(() => { this.pointLoading = false })
    },
    resetPointQuery() {
      this.pointQuery = {}
      this.pointPage.current = 1
      this.loadPoints()
    },
    openPointDialog(row) {
      this.pointForm = row ? { ...row } : this.emptyPointForm()
      this.pointDialogVisible = true
    },
    savePoint() {
      this.$refs.pointForm.validate((valid) => {
        if (!valid) return
        const api = this.pointForm.id ? pointUpdate : pointInsert
        api(this.pointForm).then(() => {
          this.$message.success('保存成功')
          this.pointDialogVisible = false
          this.loadPoints()
        })
      })
    },
    removePoint(row) {
      this.$confirm('确认删除该点位？', '提示').then(() => pointRemove(row.id)).then(() => {
        this.$message.success('删除成功')
        this.loadPoints()
      })
    },
    handleTabChange() {
      if (this.activeTab === 'channel') {
        this.loadChannels()
      } else if (this.activeTab === 'point') {
        this.loadPoints()
      } else {
        this.loadRooms()
      }
    },
    statusText(status) {
      const map = { CONNECTED: '已连接', CONNECTING: '连接中', ERROR: '异常', STOPPED: '已停止' }
      return map[status] || '已停止'
    }
  }
}
</script>
